import { generatedTypesNew } from '@css-xp/graphtypes';

const PAYMENT_ERROR_STATUS: string[] = [
  generatedTypesNew.InvoiceStatus.OPEN,
  generatedTypesNew.InvoiceStatus.DRAFT,
  generatedTypesNew.InvoiceStatus.PAYMENT_DEFERRED,
  generatedTypesNew.InvoiceStatus.VOID,
];

type InvoiceWithPossiblePaymentIssue = {
  status: string | null;
  paymentMethod: any;
  dunningStatus?: any[] | undefined;
};

export function doesInvoiceHasPaymentIssue<T extends InvoiceWithPossiblePaymentIssue>(
  invoice: T,
  isDeferredPaymentMethodSelected: boolean
): boolean {
  const hasPaymentError = isDeferredPaymentMethodSelected ? false : !!invoice?.dunningStatus?.length;

  let invoiceStatus = invoice?.status;
  if (
    invoice?.paymentMethod === generatedTypesNew.InvoicePaymentMethod.DEFERRED &&
    invoiceStatus === generatedTypesNew.InvoiceStatus.PAYMENT_DEFERRED
  ) {
    invoiceStatus = generatedTypesNew.InvoiceStatus.PAID;
  }

  if (hasPaymentError && invoiceStatus) {
    return PAYMENT_ERROR_STATUS.includes(invoiceStatus);
  }
  return false;
}
